import get from 'lodash/get'
import intersection from 'lodash/intersection'
import uniqBy from 'lodash/uniqBy'

const materialsByTags = (tagIds, materialSets) => {
  const materialMatches = {}

  materialSets.forEach(materialSet => {
    const setType = get(materialSet, 'fields.type')
    const setDescription = get(materialSet, 'fields.description')
    const categories = get(materialSet, 'fields.materialCategories')

    categories.forEach(category => {
      const categoryDisplayText = get(category, 'fields.displayText')
      const materials = get(category, 'fields.materials')

      for (const material of materials) {
        const tags = get(material, 'fields.tags') || []
        const materialTagIds = tags.map(tag => tag.id)
        const commonTagIds = intersection(materialTagIds, tagIds)

        if (commonTagIds.length === 0) {
          continue
        }

        if (Object.prototype.hasOwnProperty.call(materialMatches, category.id)) {
          materialMatches[category.id].materials.push(material)
        } else {
          materialMatches[category.id] = {
            setDescription,
            setType,
            categoryDisplayText,
            materials: [material],
          }
        }
      }
    })
  })

  for (const categoryId of Object.keys(materialMatches)) {
    const materials = materialMatches[categoryId].materials
    const uniqMaterials = uniqBy(materials, material => material.id)
    materialMatches[categoryId].materials = uniqMaterials
  }

  return materialMatches
}

const getMaterialTags = materialCategories => {
  if (!materialCategories) return
  let allTags = []
  for (const category of materialCategories) {
    const materials = get(category, 'fields.materials')
    for (const material of materials) {
      const tags = get(material, 'fields.tags')
      if (!tags) continue

      allTags = allTags.concat(tags)
    }
  }
  return uniqBy(allTags, tag => tag.id)
}

export { getMaterialTags, materialsByTags }
